import { get } from 'lodash';
import { refreshApp } from 'apps/root/actions/root';
import { config } from 'api';
import errorHandler from 'utils/errorHandler';

export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const SET_AVAILABLE_LOGIN_METHODS = 'SET_AVAILABLE_LOGIN_METHODS';
export const SET_UPGRADE_TO_LOGIN_ELEVATED_ERROR = 'SET_UPGRADE_TO_LOGIN_ELEVATED_ERROR';
export const SET_UPGRADE_TO_LOGIN_ELEVATED_IN_PROGRESS = 'SET_UPGRADE_TO_LOGIN_ELEVATED_IN_PROGRESS';

function setAvailableLoginMethods({ hasPassword, hasFacebook, hasPayPal }) {
  return {
    type: SET_AVAILABLE_LOGIN_METHODS,
    hasPassword,
    hasFacebook,
    hasPayPal,
  };
}

export function checkAvailableLoginMethods() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/auth/login/methods`)
      .then(response => dispatch(setAvailableLoginMethods(response)))
      .catch(errorHandler);
}

function setUpgradeToElevatedError(provider, code, isCaptchaRequired) {
  return {
    type: SET_UPGRADE_TO_LOGIN_ELEVATED_ERROR,
    code,
    provider,
    isCaptchaRequired,
  };
}
function setUpgradeToElevatedInProgress() {
  return {
    type: SET_UPGRADE_TO_LOGIN_ELEVATED_IN_PROGRESS,
  };
}

function upgradeToElevated(endpoint, requestBody, provider) {
  return (dispatch, getState, { network, router }) => {
    dispatch(setUpgradeToElevatedInProgress());
    const redirect = get(router.getCurrentLocation(), 'query.redirect', '/');
    return network.post(`${config.apiBasePath}${endpoint}`, {
      body: JSON.stringify(requestBody),
    })
      .then(() => dispatch(refreshApp()))
      .then(() => router.replace(redirect))
      .catch((err) => {
        const code = get(err, 'data.code') || UNKNOWN_ERROR;
        const isCaptchaRequired = get(err, 'data.captchaRequired', false);
        dispatch(setUpgradeToElevatedError(provider, code, isCaptchaRequired));
      });
  };
}

export function upgradeToElevatedUsingPassword(password, captchaResponse) {
  return upgradeToElevated('/auth/login/elevate', { password, captchaResponse }, 'regular');
}

export function upgradeToElevatedUsingFacebook(facebookResponse) {
  if (!facebookResponse.authResponse) {
    return () => {};
  }

  const requestBody = {
    uid: facebookResponse.authResponse.userID,
    signedRequest: facebookResponse.authResponse.signedRequest,
    accessToken: facebookResponse.authResponse.accessToken,
  };
  return upgradeToElevated('/auth/login/facebook/elevate', requestBody, 'fb');
}

export function upgradeToElevatedUsingPayPal(payPalResponse) {
  if (payPalResponse !== 'SUCCESS') {
    return (dispatch) => {
      dispatch(setUpgradeToElevatedError('paypal', payPalResponse));
    };
  }

  return (dispatch, getState, { router }) => {
    const redirect = get(router.getCurrentLocation(), 'query.redirect', '/');
    return dispatch(refreshApp())
      .then(() => router.replace(redirect))
      .catch((err) => {
        dispatch(setUpgradeToElevatedError('paypal', get(err, 'data.code') || UNKNOWN_ERROR));
      });
  };
}
